import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function TestSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-24 px-6 md:px-10 bg-cream overflow-hidden">
      {/* Detalles decorativos sutiles */}
      <div className="absolute -top-14 -left-14 w-44 h-44 md:w-56 md:h-56 rounded-full border border-terracotta/15 pointer-events-none" />
      <div className="absolute top-10 right-10 w-20 h-20 md:w-28 md:h-28 rounded-full bg-sand/30 flex items-center justify-center pointer-events-none">
        <i className="ri-moon-line text-terracotta/40 text-2xl md:text-3xl" />
      </div>
      <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 w-40 h-40 rounded-full bg-sand/20 pointer-events-none" />

      <div className="relative w-full max-w-3xl mx-auto text-center">
        <div className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-terracotta/10 text-terracotta">
          <i className="ri-questionnaire-line text-2xl md:text-3xl" />
        </div>

        <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
          {t('home.test.title')}
        </h2>
        <p className="font-sans text-sm md:text-base text-[#3D2B1F] max-w-xl mx-auto leading-relaxed mb-8">
          {t('home.test.desc')}
        </p>

        <Link
          to="/test-sueno"
          className="inline-flex items-center justify-center bg-terracotta text-white px-8 py-4 rounded-full font-sans text-sm md:text-base font-semibold hover:bg-brown transition-colors duration-300 whitespace-nowrap"
        >
          {t('home.test.button')}
          <i className="ri-arrow-right-line ml-2" />
        </Link>
      </div>
    </section>
  );
}